<template>
  <!-- <product-details-cards :typeData="typeData"></product-details-cards> -->
  <product-details-cards-new :typeData="typeData"></product-details-cards-new>
</template>

<script>
  // 从fromLounge, fromSearch, fromBenifits页面来的
  // import ProductDetailsCards from '@/components/BaseUi/ProductDetailsCards';
  import ProductDetailsCardsNew from '@/components/BaseUi/ProductDetailsCards/newIndex.vue';

  const type = 'retail';
  export default {
    name: 'RetailDetails',
    components: {
      // ProductDetailsCards,
      ProductDetailsCardsNew,
    },
    data() {
      return {
        typeData: null,
      };
    },
    created() {
      this.typeData = {
        airportCode: this.$route.query.airportCode,
        lang: this.$i18n.locale,
        code: this.$route.query.retailCodes,
        type,
      };
    },
  };
</script>

<style></style>
